import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { Pagination } from '@shared/models';

import {
  StoreAvailableAdjustmentRequestListContent,
  StoreAvailableAdjustmentRequestSearchCriteria,
  StoreAvailableAdjustmentRequestViewResponse,
  StoreAvailableApproveRejectPayload
} from '../../model/store-available-adjustment-request.model';

export const loadStoreAvailableAdjustmentRequestListRequest = createAction(
  '[StoreAvailableAdjustment] Load StoreAvailableAdjustmentList Request',
  props<{ criteriaObj: StoreAvailableAdjustmentRequestSearchCriteria }>()
);

export const loadStoreAvailableAdjustmentRequestListResponse = createAction(
  '[StoreAvailableAdjustment] Load StoreAvailableAdjustmentList Response',
  props<{ data: Pagination<StoreAvailableAdjustmentRequestListContent> }>()
);

export const StoreAvailableAdjustmentRequestViewAction = createActionGroup({
  source: 'Store Available Adjustment Request View',
  events: {
    Request: props<{ requestNo: string }>(),
    Response: props<{ data: StoreAvailableAdjustmentRequestViewResponse }>(),
    'Reset View': emptyProps(),
    'Approve Request': props<{ payload: StoreAvailableApproveRejectPayload }>(),
    'Reject Request': props<{ payload: StoreAvailableApproveRejectPayload }>(),
    'Regenerate Workflow Request': props<{ requestNo: string; requestId: string; version: number }>()
  }
});
